import { NButton, NFormItem, NPopover, NSelect, NSpace } from 'naive-ui';
import { computed, h, reactive, ref, RendererElement } from 'vue';

const commitedFilters = ref({
  title: null,
  arena: null,
  surfaceType: null,
  distanceType: null,
  weatherType: null,
  ticketOrder: null,
  totalParticipants: null
});
const filtersModel = reactive({ ...commitedFilters.value });

const maxTicketPrice = ref<number | null>(null);
const minTicketPrice = ref<number | null>(null);
const refresh = ref<boolean>(false);

const filtersChanged = computed(() => {
  let aux = false;
  if (maxTicketPrice.value != undefined || minTicketPrice.value != undefined) {
    aux = true;
  }
  Object.keys(commitedFilters.value).forEach(key => {
    if (commitedFilters.value[key] != undefined) {
      aux = true;
    }
  });
  return aux;
});

const generateFilterUI = (name: string, used: boolean, filterProp: string, search: () => void, menu: RendererElement[]) => {
  const filterTrigger = h(
    NButton,
    {
      type: used ? 'info' : 'default',
      ghost: true,
      size: 'small',
      style: 'padding: .5rem'
    },
    {
      default: () => name
    }
  );
  const filterWrapper = h(
    NPopover,
    {
      trigger: 'click',
      placement: 'bottom',
      style: 'padding: 0'
    },
    {
      default: () =>  h(
        NSpace,
        { style: { padding: '1rem' }, vertical: true },
        {
          default: () => [
            ...menu,
            h(
              NSpace,
              {
                justify: 'end'
              },
              {
                default: () => [
                  h(
                    NButton,
                    {
                      onClick: () => {
                        filtersModel[filterProp] = null;
                        search();
                      },
                      type: 'info',
                      ghost: true,
                      style: { width: '100%' }
                    },
                    { default: () => 'CLEAR' }
                  ),
                  h(
                    NButton,
                    {
                      onClick: () => {
                        search();
                      },
                      type: 'info'
                    },
                    { default: () => 'SEARCH' }
                  )
                ]
              }
            )
          ]
        }
      ),
      trigger: () => filterTrigger
    }
  );

  return filterWrapper;
};

const generateSelectMenu = (name: string, property: string, options: any[]): RendererElement => {
  return h(
    NFormItem,
    {
      label: name,
      showFeedback: false
    },
    {
      default: () => (h(
        NSelect,
        {
          placeholder: name,
          value: filtersModel[property],
          options: options.map((el, index) => {
            if (el.label) {
              return el;
            }
            return {
              value: index,
              label: el
            };
          }),
          onUpdateValue: (ev: number) => {
            filtersModel[property] = ev;
          }
        }
      ))
    }
  );
};

export {
  commitedFilters,
  filtersModel,
  maxTicketPrice,
  minTicketPrice,
  filtersChanged,
  generateFilterUI,
  generateSelectMenu,
  refresh
};
